import React, { useCallback, useContext, useEffect, useImperativeHandle, useRef } from 'react'
import SearchLocationInput from 'components/Search/SearchForm/SearchLocationInput/LocationInput'
import { SearchMenuStates } from 'components/Search/type'
import { EXPERIENCE_TYPEAHEAD_SEARCH_TYPES, EXPERIENCE_LOCATION_SEARCH_TITLE_LABEL, EXPERIENCE_LOCATION_SEARCH_PLACEHOLDER_LABEL } from 'constants/experience'
import { GlobalSearchDispatchContext, GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import { GlobalSearchStateActions } from 'contexts/GlobalSearch/GlobalSearchState'

const ExperienceSearchLocationSelect = React.forwardRef<HTMLInputElement, any>((props, ref) => {
  const inputRef = useRef<HTMLInputElement>()
  const { activeMenu } = useContext(GlobalSearchStateContext)
  const searchDispatch = useContext(GlobalSearchDispatchContext)
  const isOpen = activeMenu === SearchMenuStates.Locations

  useEffect(() => {
    if (isOpen) {
      inputRef.current?.focus()
    }
  }, [isOpen])

  useImperativeHandle(ref, () => inputRef.current)

  const onClose = useCallback(() => {
    searchDispatch({ type: GlobalSearchStateActions.SET_ACTIVE_MENU, menu: SearchMenuStates.Closed })
  }, [searchDispatch])

  const onOpen = useCallback(() => {
    searchDispatch({ type: GlobalSearchStateActions.SET_ACTIVE_MENU, menu: SearchMenuStates.Locations })
  }, [searchDispatch])

  return <SearchLocationInput
    isToggled={isOpen}
    typeaheadTypes={EXPERIENCE_TYPEAHEAD_SEARCH_TYPES}
    titleLabel={EXPERIENCE_LOCATION_SEARCH_TITLE_LABEL}
    placeholder={EXPERIENCE_LOCATION_SEARCH_PLACEHOLDER_LABEL}
    ref={inputRef}
    onBlur={onClose}
    onLocationToggle={onOpen}
  />
})

export default ExperienceSearchLocationSelect
